"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.odataFunctions = void 0;
const odataFunctions = {
    substringof: (type, value, property) => query => type === 'and'
        ? query.where(property, 'like', `%${value}%`)
        : query.orWhere(property, 'like', `%${value}%`),
};
exports.odataFunctions = odataFunctions;
//# sourceMappingURL=knex-odata-functions.js.map